import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"
import { 
  Database, 
  GraduationCap, 
  Settings, 
  Code, 
  Smartphone, 
  Brain,
  Clock,
  BarChart3,
  Target,
  CreditCard,
  Car,
  FileText,
  Server,
  Cloud,
  Layers,
  User
} from 'lucide-react'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const iconMap = {
  Database,
  GraduationCap,
  Settings,
  Code,
  Smartphone,
  Brain,
  Clock,
  BarChart3,
  Target,
  CreditCard,
  Car,
  FileText,
  Server,
  Cloud,
  Layers,
  User
}

export function getIcon(iconName: string) {
  return iconMap[iconName as keyof typeof iconMap] || Database
}

export { toSlug, getServiceHref } from './slug'
